import type { FC, ReactNode } from 'react'

import { Marquee } from '@/components/generals/marquee'
import { Reveal } from '@/components/generals/reveal'
import { PartnerWordmark } from '@/components/home/partner-wordmark'
import { partnerRows } from '@/constants/home'

/** Two rows of customer wordmarks drifting in opposite directions. Hovering a row slows it. */
export const TrustMarquee: FC = (): ReactNode => {
    return (
        <section id='customers' aria-labelledby='customers-title' className='section-y relative'>
            <div className='shell'>
                <Reveal as='h2' id='customers-title' className='text-center font-heading text-lg font-medium leading-snug tracking-[-0.02em] text-ink-soft sm:text-xl'>
                    <span className='block'>
                        Trusted by fast-growing
                    </span>

                    <span className='block text-stone'>
                        shippers around the world
                    </span>
                </Reveal>
            </div>

            <Reveal delay={120} className='mt-12 space-y-6 sm:space-y-8'>
                <ul className='sr-only'>
                    {partnerRows.flat().map(name => (
                        <li key={name}>
                            {name}
                        </li>
                    ))}
                </ul>

                {partnerRows.map((row, index) => (
                    <div key={row.join()} aria-hidden='true'>
                        <Marquee
                            speed={index === 0 ? 26 : 22}
                            direction={index === 0 ? 'left' : 'right'}
                            hoverFactor={0.25}
                            className='mask-fade-x'
                            trackClassName='gap-16 pr-16 py-2 text-[20px] text-ink/60 sm:gap-24 sm:pr-24 sm:text-[22px]'
                        >
                            {[...row, ...row].map((name, position) => (
                                <span key={`${name}-${position}`} className='transition-colors duration-300 hover:text-ink'>
                                    <PartnerWordmark name={name} />
                                </span>
                            ))}
                        </Marquee>
                    </div>
                ))}
            </Reveal>
        </section>
    )
}
